// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.modal-overlay .modal-center {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.modal-overlay .modal-center {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  overflow: auto;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
  border-radius: 24px;
  width: auto;
  margin-inline: 2rem;
}
.modal-overlay .modal-header {
  display: flex;
  padding: 10px;
  justify-content: center;
}
.modal-overlay .modal-header p {
  font-size: 16px;
  font-weight: 700;
}
.modal-overlay .close-button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  color: #888;
  display: flex;
  justify-content: end;
  margin-inline: 2rem;
}
.modal-overlay .modal-content {
  padding: 20px;
  padding: 20px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.IntiateCharging--custom-modal {
  padding-top: 2.5rem;
}
.IntiateCharging--custom-modal .modal-content {
  padding: 0px 20px 20px 20px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Common/Modal/Modal.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AACJ;AACI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AACR;AAGI;EACI,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,0CAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;AADR;AAKI;EACI,aAAA;EACA,aAAA;EACA,uBAAA;AAHR;AAIQ;EACI,eAAA;EACA,gBAAA;AAFZ;AAMI;EACI,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,oBAAA;EACA,mBAAA;AAJR;AAQI;EACI,aAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;AANR;;AAWA;EACI,mBAAA;AARJ;AASI;EACI,2BAAA;AAPR","sourcesContent":[".modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.2);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 9999;\n\n    .modal-center {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        flex-direction: column;\n        // margin-inline: 2rem;\n    }\n    \n    .modal-center {\n        background-color: #fff;\n        border: 1px solid #ccc;\n        border-radius: 4px;\n        overflow: auto;\n        box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);\n        border-radius: 24px;\n        width: auto;\n        margin-inline: 2rem;\n    }\n\n\n    .modal-header {\n        display: flex;\n        padding: 10px;\n        justify-content: center;\n        p{\n            font-size: 16px;\n            font-weight: 700;\n        }\n    }\n\n    .close-button {\n        background: none;\n        border: none;\n        cursor: pointer;\n        font-size: 18px;\n        color: #888;\n        display: flex;\n        justify-content: end;\n        margin-inline: 2rem;\n\n    }\n\n    .modal-content {\n        padding: 20px;\n        padding: 20px;\n        display: flex;\n        justify-content: center;\n        flex-direction: column;\n        // text-align: center;\n    }\n}\n\n.IntiateCharging--custom-modal{\n    padding-top: 2.5rem;\n    .modal-content{\n        padding: 0px 20px 20px 20px;\n    }\n}\n\n// .wallet-custom-modal{\n//     margin-inline: 3rem;\n// }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
